module.exports = __webpack_public_path__ + "static/media/menu.dcf5aa13.svg";